<div class="col-12 mt-3">
  <div class="row">
    <div class="col-12 text-left pl-md-0 pr-md-3 px-0">
      <h2 class="font-weight-bold mb-4">{{ 'invoiceslist.Historial de facturación' | translate }}</h2>
    </div>
  </div>

  <div class="row empty-section" *ngIf="noResults">
    <div class="col-12 text-center my-auto">
      <img class="logo mb-4" src="assets/img/logo_opacity-21.png">
      <p>{{ 'invoiceslist.No se han encontrado resultados' | translate }}</p>
    </div>
  </div>
</div>
<table class="table table-hover table-dark mb-3" *ngIf="!noResults">
  <thead class="thead-dark">
    <tr>
      <th scope="col">{{ 'invoiceslist.Fecha' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Número de factura' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Período de facturación' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Proveedor' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Importe' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Estado' | translate }}</th>
      <th scope="col" class="text-center">{{ 'invoiceslist.Tipo' | translate }}</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody class="">

    <tr *ngFor="let invoice of invoices | paginate: pagination;">
      <td scope="row" class="font-weight-bold">{{ invoice.invoiceDetails.invoiceDate }}</td>
      <td class="text-center">{{ invoice.invoiceDetails.serialNumber }}</td>
      <td class="text-center">{{ invoice.invoiceDetails.invoiceMonthPeriod }}/{{ invoice.invoiceDetails.invoiceYearPeriod }}</td>
      <td class="text-center">{{ invoice.company.companyName }}</td>
      <td class="font-weight-bold text-center">{{ invoice.invoiceDetails.billingDetails.commission }} &euro;</td>
      <td class="text-center">
        <div [ngClass]="'status' | invoiceStateClassPipe: invoice.invoiceDetails.settledUp">
          <div class="dot"></div> {{ invoice.invoiceDetails.settledUp | invoiceStatePayment | translate }}
        </div>
      </td>
      <td class="text-center">
        {{ invoice.invoiceDetails.chargePending | invoicePaymentTypeAdminPipe: invoice.invoiceDetails.chargeCompleted : invoice.invoiceDetails.paymentPending : invoice.invoiceDetails.paymentCompleted | translate }}
        {{ invoice.invoiceDetails.billingDetails.payment | invoicePaymentTypeAmountPipe }}
      </td>
      <td class="px-0">
        <label class="btn-more-vert dropdown">
          <div class="dd-button">
            <img class="ic-mid" src="assets/img/ic_more-vert.svg">
          </div>

          <input type="checkbox" class="dd-input" id="test">

          <ul class="dd-menu text-right">

            <li>
              <a (click)="onInvoiceDetails(invoice.invoiceDetails.id)">
                {{ 'invoiceslist.Ver detalles' | translate }}
              </a>
            </li>

            <li class="divider"></li>

            <li>
              <a (click)="onInvoiceDownload(invoice.invoiceDetails)">
                {{ 'invoiceslist.Descargar factura' | translate }}
              </a>
            </li>

            <li class="divider"></li>

            <li *ngIf="invoice.invoiceDetails.paymentPending">
              <a (click)="onPaymentToProvider(invoice.invoiceDetails.id)">
                {{ 'invoiceslist.Pagar al proveedor' | translate }}
              </a>
            </li>

            <li class="divider"></li>

            <li *ngIf="invoice.invoiceDetails.chargePending || invoice.invoiceDetails.paymentPending">
              <a (click)="onManualSettleUp(invoice.invoiceDetails.id)">
                {{ 'invoiceslist.Marcar como pagado' | translate }}
              </a>
            </li>

            <li class="divider"></li>

            <li *ngIf="invoice.invoiceDetails.chargePending">
              <a (click)="onResendPaymentRequest(invoice.invoiceDetails.id)">
                {{ 'invoiceslist.Enviar recordatorio' | translate }}
              </a>
            </li>

          </ul>

        </label>
      </td>
    </tr>
  </tbody>
</table>